export default __webpack_public_path__ + "b6cfb448a962a262c4465f1f686c961e.png";